import 'notivue/notification.css'; // Only needed if using built-in <Notification />
import 'notivue/animations.css';
import { createNotivue } from 'notivue';
import { App } from 'vue';

export function bootNotivue({ app }: { app: App }) {
  const notivue = createNotivue({
    position: 'top-center',
  });

  app.use(notivue);
}
